var PolygonGeneralDataToGoModelUtil = /** @class */ (function () {
    function PolygonGeneralDataToGoModelUtil(diagram, goModel) {
        this.diagram = diagram;
        this.goModel = goModel;
    }
    PolygonGeneralDataToGoModelUtil.prototype.saveComponentProperty = function (property, value) {
        this.diagram.model.setDataProperty(this.goModel, property, value);
    };
    PolygonGeneralDataToGoModelUtil.prototype.saveToGoJsModel = function (data) {
        this.saveComponentProperty('stroke', data.stroke);
        this.saveComponentProperty('strokeWidth', data.strokeWidth);
        this.saveComponentProperty('lineType', data.lineType);
        this.saveComponentProperty('fill', data.fill);
    };
    return PolygonGeneralDataToGoModelUtil;
}());
export { PolygonGeneralDataToGoModelUtil };
